export const CHECKOUT_URL = 'https://halloween-pe-ready.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRICE = '$19'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/9Fcbh82d8wyvWLFGeLMKcr/Pack_promocional_Halloween_PE_Ready_dado_en_el_gimnasio-Photoroom.webp'

export const PRINT_PACK_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/59d1c1bb-07db-4345-a49c-cd0cd4f892a3.jpg'

export const PRODUCT_IMAGE_ALT =
  'Halloween PE Ready digital system: main guide, tablet showing a visual lesson plan, game cards, stations, lesson plans and printable resources'
